import { Component, Input, OnInit } from '@angular/core';
import { PriceService } from '@manager-app/storage/service/price.service';
import { HcToastrService } from '@manager-app/service/toastr.service';
import { ComponentType, HxAuthService, HxStoreProductService, PermissionKey, PriceShortModel, SavePriceRequest } from 'hx-services';
import { ErrorHandlerService } from '@manager-app/service/error-handler.service';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { NgFor, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HxDateSelectComponent, HxLoaderComponent } from 'hx-component';
import { NgOptionComponent, NgSelectComponent } from '@ng-select/ng-select';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-price-new',
    templateUrl: './price-new.component.html',
    styleUrls: ['./price-new.component.css'],
    imports: [NgIf, NgFor, FormsModule, HxDateSelectComponent, NgSelectComponent, NgOptionComponent, NgbTooltip, HxLoaderComponent, TranslocoPipe]
})
export class PriceNewComponent implements OnInit {
  @Input() storeProductId: number;
  @Input() productInfoId: number;
  list: PriceShortModel[] = [];
  isLoading = {
    list: false
  };
  today = Date.now();
  typeOptions: { id: ComponentType, label: string}[] = [
    {id: ComponentType.cb, label: 'component.' + ComponentType.cb},
    {id: ComponentType.cc, label: 'component.' + ComponentType.cc},
    {id: ComponentType.manager, label: 'component.' + ComponentType.manager},
  ];
  components: ComponentType[] = [];
  priceUpsert = false;

  constructor(
    private priceService: PriceService,
    private toastr: HcToastrService,
    private errorHandlerService: ErrorHandlerService,
    private storeProductService: HxStoreProductService,
    private auth: HxAuthService,
    private tr: TranslocoService
  ) { }

  ngOnInit() {
    this.loadList();
    this.storeProductService.getStoreProduct(this.storeProductId).subscribe(storeProduct => {
      this.auth.getPermissions({ permissions: [PermissionKey.price_upsert_permission] }).subscribe(result => {
        this.priceUpsert = result && result.length > 0;
      });
    });
  }

  async savePrices(item: PriceShortModel) {
    const {id, enabled, ...rest} = item;
    const obj: SavePriceRequest = rest as SavePriceRequest;
    const result = id
      ? await this.priceService.updatePrice(id, obj)
      : await this.priceService.createPrice(obj);
    if (result) {
      this.toastr.success(this.tr.translate('price-new.ts.saveSuccess'));
    }
    this.loadList();
  }

  addField() {
    this.addItem();
  }

  removeField(item: PriceShortModel, index: number) {
    if (item && item.id) {
      this.deleteItem(item.id);
    } else {
      this.list.splice(index, 1);
    }
  }

  async changeSwitchPrice(price: PriceShortModel) {
    try {
      await this.priceService.changePriceState(price.id, {enabled: price.enabled});
      if (price.enabled) {
        this.toastr.success(this.tr.translate('price-new.ts.onSuccess'));
      } else {
        this.toastr.success(this.tr.translate('price-new.ts.offSuccess'));
      }
      this.loadList();
    } catch (err) {
      this.errorHandlerService.check(err);
    }
  }

  private async loadList() {
    if (this.storeProductId) {
      this.list = [];
      this.isLoading.list = true;
      try {
        const result = await this.priceService.getPriceList({storeProductId: this.storeProductId, includeDisabled: true});
        this.list = result.list || [];
      } finally {
        this.isLoading.list = false;
      }
    }
  }

  private addItem() {
    const obj = {
      productInfoId: this.productInfoId,
      storeProductId: this.storeProductId,
      amount: 1
    } as PriceShortModel;

    this.list.push(obj);
  }

  private async deleteItem(id: number) {
    if (id) {
      try {
        await this.priceService.deletePrice(id);
        this.toastr.success(this.tr.translate('price-new.ts.deleteSuccess'));
        this.loadList();
      } catch (err: any) {
        if (err?.error) {
          this.toastr.error(`price.${err.error.message}`);
        }
      }
    }
  }
}
